<!-- eslint-disable max-len -->
<template>
  <div class="component-card">
    <!-- <j-title-header :options="title"/> -->

    <div
      class="container-top-admin">
      <div class="m__b--20 m__l--20">
        <i
          class="fa fa-arrow-left fa-lg cursor-pointer p__t--3"
          @click="$router.push('/data-siswa')"/>
        <div class="top-label-admin font-gotham-bold"> {{ data_master ? data_master.nama_siswa : '' }} <br>
        <span class="top-span-admin font-gotham-bold"> {{ data_master ? data_master.nis : '' }} </span> </div>
        <div class="cursor-pointer delete-top-admin">
          <i
            v-if="!readOnly"
            id="popoverChangePasswd"
            class="fa fa-ellipsis-v fa-2x"/>
        </div>
      </div>

      <div class="d-flex">
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'profile'}"
          class="tab-experience-manager m__r--15 p__l--10 p__r--10"
          @click="tabSelected = 'profile'">
          PROFILE
        </div>
        <!-- <div
          :class="{'tab-experience-manager-active' : tabSelected === 'kelas'}"
          class="tab-experience-manager m__r--15 p__l--10 p__r--10"
          @click="tabSelected = 'kelas'">
          BAGI KELAS
        </div> -->
      </div>
    </div>

    <b-row class="m__t--45">
      <b-col md="8">
        <b-form-group :class="{'error-input' : $v.data_master.nama_siswa.$error}">
          <label> Nama Lengkap </label>
          <j-input
            v-model="$v.data_master.nama_siswa.$model"
            :disabled="readOnly"
            placeholder="Nama Lengkap"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nis.$error}">
          <label> NIS </label>
          <j-input
            v-model="$v.data_master.nis.$model"
            :disabled="readOnly"
            placeholder="NIS"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nisn.$error}">
          <label> NISN </label>
          <j-input
            v-model="$v.data_master.nisn.$model"
            :disabled="readOnly"
            placeholder="NISN"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.status.$error}">
          <label> Status </label>
          <j-single-select
            v-model="$v.data_master.status.$model"
            :options="list_status"
            :disabled="readOnly"
            placeholder="Pilih Status"
            label="name"/>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group :class="{'error-input' : $v.data_master.foto_siswa.$error}">
          <label> Photo </label><br>
          <j-singleupload
            v-model="$v.data_master.foto_siswa.$model"
            :accepted-file-type="['jpg', 'png', 'jpeg']"
            :img-default="$v.data_master.foto_siswa.$model"
            :api-token="token"
            :url-upload="url_upload"
            :disabled="readOnly"
            @url="getUrl"/>
          <label v-if="!readOnly">
            Please choose file with supported format file jpg, png, jpeg.
          </label>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-form-group :class="{'error-input' : $v.data_master.tempat_lahir.$error}">
          <label> Tempat Lahir </label>
          <j-input
            v-model="$v.data_master.tempat_lahir.$model"
            :disabled="readOnly"
            placeholder="Tempat Lahir"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.tanggal_lahir.$error}">
          <label> Tanggal Lahir </label>
          <j-datepicker
            v-model="$v.data_master.tanggal_lahir.$model"
            :disabled="readOnly"
            placeholder="Tanggal Lahir"
            format="MMM dd, yyyy"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.jenis_kelamin.$error}">
          <label> Jenis Kelamin </label>
          <b-form-radio-group
            v-model="$v.data_master.jenis_kelamin.$model"
            :options="list_jenis_kelamin"
            :stacked="true"
            :disabled="readOnly"
            class="jFormGroup"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.agama.$error}">
          <label> Agama </label>
          <j-single-select
            v-model="$v.data_master.agama.$model"
            :options="list_agama"
            :disabled="readOnly"
            placeholder="Pilih Agama"
            label="name"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.status_siswa.$error}">
          <label> Status Dalam Keluarga </label>
          <j-input
            v-model="$v.data_master.status_siswa.$model"
            :disabled="readOnly"
            placeholder="Status Dalam Keluarga"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.anak_ke.$error}">
          <label> Anak Ke </label>
          <j-input
            v-model="$v.data_master.anak_ke.$model"
            :disabled="readOnly"
            placeholder="Anak Ke"
            type="number"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.alamat_siswa.$error}">
          <label> Alamat Siswa </label>
          <j-textarea
            v-model="$v.data_master.alamat_siswa.$model"
            :disabled="readOnly"
            placeholder="Alamat Siswa"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.no_telepon.$error}">
          <label> Nomor Telepon Siswa </label>
          <j-input
            v-model="$v.data_master.no_telepon.$model"
            :disabled="readOnly"
            placeholder="Nomor Telepon Rumah"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.sekolah_asal.$error}">
          <label> Sekolah Asal </label>
          <j-input
            v-model="$v.data_master.sekolah_asal.$model"
            :disabled="readOnly"
            placeholder="Sekolah Asal"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.diterima_dikelas.$error}">
          <label> Diterima Di Kelas </label>
          <j-input
            v-model="$v.data_master.diterima_dikelas.$model"
            :disabled="readOnly"
            placeholder="Diterima Di Kelas"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.tanggal_diterima.$error}">
          <label> Tanggal Diterima </label>
          <j-datepicker
            v-model="$v.data_master.tanggal_diterima.$model"
            :disabled="readOnly"
            placeholder="Tanggal Diterima"
            format="MMM dd, yyyy"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nama_ayah.$error}">
          <label> Nama Ayah Kandung </label>
          <j-input
            v-model="$v.data_master.nama_ayah.$model"
            :disabled="readOnly"
            placeholder="Nama Ayah Kandung"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nama_ibu.$error}">
          <label> Nama Ibu Kandung </label>
          <j-input
            v-model="$v.data_master.nama_ibu.$model"
            :disabled="readOnly"
            placeholder="Nama Ibu Kandung"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.alamat_ortu.$error}">
          <label> Alamat Orang Tua </label>
          <j-textarea
            v-model="$v.data_master.alamat_ortu.$model"
            :disabled="readOnly"
            placeholder="Alamat Orang Tua"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.no_telepon_rumah.$error}">
          <label> Nomor Telepon Rumah </label>
          <j-input
            v-model="$v.data_master.no_telepon_rumah.$model"
            :disabled="readOnly"
            placeholder="Nomor Telepon Rumah"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.pekerjaan_ayah.$error}">
          <label> Pekerjaan Ayah </label>
          <j-input
            v-model="$v.data_master.pekerjaan_ayah.$model"
            :disabled="readOnly"
            placeholder="Pekerjaan Ayah"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.pekerjaan_ibu.$error}">
          <label> Pekerjaan Ibu </label>
          <j-input
            v-model="$v.data_master.pekerjaan_ibu.$model"
            :disabled="readOnly"
            placeholder="Pekerjaan Ibu"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nama_wali.$error}">
          <label> Nama Wali Siswa </label>
          <j-input
            v-model="$v.data_master.nama_wali.$model"
            :disabled="readOnly"
            placeholder="Nama Wali Siswa"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.alamat_wali.$error}">
          <label> Alamat Wali </label>
          <j-textarea
            v-model="$v.data_master.alamat_wali.$model"
            :disabled="readOnly"
            placeholder="Alamat Wali"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.notlp_wali.$error}">
          <label> Nomor Telepon Wali </label>
          <j-input
            v-model="$v.data_master.notlp_wali.$model"
            :disabled="readOnly"
            placeholder="Nomor Telepon Wali"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.pekerjaan_wali.$error}">
          <label> Pekerjaan Wali </label>
          <j-input
            v-model="$v.data_master.pekerjaan_wali.$model"
            :disabled="readOnly"
            placeholder="Pekerjaan Wali"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nik_kitas.$error}">
          <label> NIK/No. KITAS </label>
          <j-input
            v-model="$v.data_master.nik_kitas.$model"
            :disabled="readOnly"
            placeholder="NIK/No. KITAS"
            type="number"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.warga_negara.$error}">
          <label> Kewarganegaraan </label>
          <j-input
            v-model="$v.data_master.warga_negara.$model"
            :disabled="readOnly"
            placeholder="Kewarganegaraan"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.berkebutuhan_khusus.$error}">
          <label> Berkebutuhan Khusus </label>
          <j-input
            v-model="$v.data_master.berkebutuhan_khusus.$model"
            :disabled="readOnly"
            placeholder="Berkebutuhan Khusus"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.rt.$error}">
          <label> RT </label>
          <j-input
            v-model="$v.data_master.rt.$model"
            :disabled="readOnly"
            placeholder="RT"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.rw.$error}">
          <label> RW </label>
          <j-input
            v-model="$v.data_master.rw.$model"
            :disabled="readOnly"
            placeholder="RW"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.dusun.$error}">
          <label> Dusun </label>
          <j-input
            v-model="$v.data_master.dusun.$model"
            :disabled="readOnly"
            placeholder="Dusun"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.desa_kelurahan.$error}">
          <label> Kelurahan/Desa </label>
          <j-input
            v-model="$v.data_master.desa_kelurahan.$model"
            :disabled="readOnly"
            placeholder="Kelurahan/Desa"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.kecamatan.$error}">
          <label> Kecamatan </label>
          <j-input
            v-model="$v.data_master.kecamatan.$model"
            :disabled="readOnly"
            placeholder="Kecamatan"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.kodepos.$error}">
          <label> Kode POS </label>
          <j-input
            v-model="$v.data_master.kodepos.$model"
            :disabled="readOnly"
            placeholder="Kode POS"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.tempat_tinggal.$error}">
          <label> Tempat Tinggal </label>
          <j-single-select
            v-model="$v.data_master.tempat_tinggal.$model"
            :options="list_tempat_tinggal"
            :disabled="readOnly"
            placeholder="Pilih Tempat Tinggal"
            label="name"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.moda_transportasi.$error}">
          <label> Moda Transportasi </label>
          <j-single-select
            v-model="$v.data_master.moda_transportasi.$model"
            :options="list_moda_transportasi"
            :disabled="readOnly"
            placeholder="Pilih Moda Transportasi"
            label="name"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.penerima_kps.$error}">
          <label> Penerima KPS </label>
          <j-input
            v-model="$v.data_master.penerima_kps.$model"
            :disabled="readOnly"
            placeholder="Penerima KPS"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.no_kps.$error}">
          <label> No KPS </label>
          <j-input
            v-model="$v.data_master.no_kps.$model"
            :disabled="readOnly"
            placeholder="No KPS"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.layak_pip.$error}">
          <label> Layak PIP </label>
          <j-input
            v-model="$v.data_master.layak_pip.$model"
            :disabled="readOnly"
            placeholder="Layak PIP"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.alasan_layak_pip.$error}">
          <label> Alasan Layak PIP </label>
          <j-single-select
            v-model="$v.data_master.alasan_layak_pip.$model"
            :options="list_alasan_layak_pip"
            :disabled="readOnly"
            placeholder="Pilih Alasan Layak PIP"
            label="name"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.no_kip.$error}">
          <label> No KIP </label>
          <j-input
            v-model="$v.data_master.no_kip.$model"
            :disabled="readOnly"
            placeholder="No KIP"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.nama_tertera_di_kip.$error}">
          <label> Nama Tertera di KIP </label>
          <j-input
            v-model="$v.data_master.nama_tertera_di_kip.$model"
            :disabled="readOnly"
            placeholder="Nama Tertera di KIP"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.no_kks.$error}">
          <label> Nomor KKS </label>
          <j-input
            v-model="$v.data_master.no_kks.$model"
            :disabled="readOnly"
            placeholder="Nomor KKS"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.bank.$error}">
          <label> Bank </label>
          <j-input
            v-model="$v.data_master.bank.$model"
            :disabled="readOnly"
            placeholder="Bank"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.no_akta_lahir.$error}">
          <label> Nomor Registrasi Akta Lahir </label>
          <j-input
            v-model="$v.data_master.no_akta_lahir.$model"
            :disabled="readOnly"
            placeholder="Nomor Registrasi Akta Lahir"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.no_rekening_bank.$error}">
          <label> No. Rekening Bank </label>
          <j-input
            v-model="$v.data_master.no_rekening_bank.$model"
            :disabled="readOnly"
            placeholder="No. Rekening Bank"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.rekening_atas_nama.$error}">
          <label> Rekening Atas Nama </label>
          <j-input
            v-model="$v.data_master.rekening_atas_nama.$model"
            :disabled="readOnly"
            placeholder="Rekening Atas Nama"/>
        </b-form-group>

        <b-form-group :class="{'error-input' : $v.data_master.npsn_sekolah_asal.$error}">
          <label> NPSN Sekolah Asal </label>
          <j-input
            v-model="$v.data_master.npsn_sekolah_asal.$model"
            :disabled="readOnly"
            placeholder="NPSN Sekolah Asal"/>
        </b-form-group>
      </b-col>
    </b-row>

    <b-button
      v-if="!readOnly"
      class="btn blue m__t--20"
      @click="saveData">
      Update
    </b-button>

    <!-- <b-row>
      <b-col md="6">
        <b-button
          class="btn red m__t--20"
          @click="deleteData">
          Delete
        </b-button>
      </b-col>
      <b-col md="6">
        <div class="float-to-right m__t--20">
          <b-button
            class="btn blue m__r--5"
            @click="saveData">
            Update
          </b-button>
          <b-button
            class="btn gray"
            @click="$router.replace('/data-siswa')">
            Cancel
          </b-button>
        </div>
      </b-col>
    </b-row> -->

    <b-popover
      ref="changePasswdModal"
      :show.sync="popoverChangePasswdShow"
      target="popoverChangePasswd"
      placement="left">
      <div
        class="cursor-pointer"
        @click="createData">Change Password</div>
      <div
        class="m__b--10 cursor-pointer"
        @click="deleteData">Delete</div>
    </b-popover>

    <b-modal
      ref="modalChangePasswd"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">CHANGE PASSWORD</h2>

      <b-form-group :class="{'error-input' : $v.data_pswd.password.$error}">
        <label> Password </label>
        <j-input
          v-model="$v.data_pswd.password.$model"
          :type="password"
          :error-required="$v.data_pswd.password.$error"
          placeholder="Type New Password"/>
      </b-form-group>
      <b-form-checkbox v-model="show_pass">show password</b-form-checkbox><br><br>

      <b-form-group :class="{'error-input' : $v.data_pswd.confirm_password.$error || data_pswd.password !== data_pswd.confirm_password}">
        <label> Confirm Password </label>
        <j-input
          v-model="$v.data_pswd.confirm_password.$model"
          :error-message="'Password dan Confirm Password harus sama'"
          :error-required="$v.data_pswd.password.$error || data_pswd.password !== data_pswd.confirm_password"
          :type="confirm_password"
          placeholder="Type Confirm Password"/>
      </b-form-group>
      <b-form-checkbox v-model="show_conpass">show password</b-form-checkbox>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn gray m__r--5"
          @click="closeModal">
          Cancel
        </b-button>
        <b-button
          class="btn blue"
          @click="changePassword">
          Save
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

export default {
  components: {
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Update Data',
      },
      tabSelected: 'profile',
      popoverChangePasswdShow: false,
      data_pswd: {
        password: '',
        confirm_password: '',
      },
      show_pass: false,
      show_conpass: false,

      data_master: {
        nis: '',
        nisn: '',
        nama_siswa: '',
        alamat_siswa: '',
        foto_siswa: null,
        tempat_lahir: '',
        tanggal_lahir: null,
        jenis_kelamin: null,
        agama: null,
        warga_negara: '',
        anak_ke: 0,
        jml_sdr_kandung: 0,
        jml_sdr_tiri: 0,
        jml_sdr_angkat: 0,
        yatim_piatu: '',
        bahasa_harian: '',
        status_siswa: null,
        ket_status: '',
        post_date: null,
        nama_ayah: '',
        nama_ibu: '',
        alamat_ortu: '',
        notlp_ortu: '',
        nama_wali: '',
        alamat_wali: '',
        notlp_wali: '',
        pekerjaan_ayah: '',
        pekerjaan_ibu: '',
        pekerjaan_wali: '',
        tahunmasuk: '',
        sekolah_asal: '',
        diterima_dikelas: '',
        tanggal_diterima: null,
        nik_kitas: '',
        berkebutuhan_khusus: '',
        rt: '',
        rw: '',
        dusun: '',
        desa_kelurahan: '',
        kecamatan: '',
        kodepos: '',
        tempat_tinggal: null,
        moda_transportasi: null,
        penerima_kps: '',
        no_kps: '',
        layak_pip: '',
        alasan_layak_pip: null,
        no_kip: '',
        nama_tertera_di_kip: '',
        no_kks: '',
        bank: '',
        no_akta_lahir: '',
        no_rekening_bank: '',
        rekening_atas_nama: '',
        npsn_sekolah_asal: '',
        nik_ayah: '',
        tahun_lahir_ayah: '',
        pendidikan_ayah: '',
        penghasilan_ayah: '',
        kebutuhan_khusus_ayah: '',
        nik_ibu: '',
        tahun_lahir_ibu: '',
        pendidikan_ibu: '',
        penghasilan_ibu: '',
        kebutuhan_khusus_ibu: '',
        nik_wali: '',
        tahun_lahir_wali: '',
        pendidikan_wali: '',
        penghasilan_wali: '',
        no_telepon_rumah: '',
        no_telepon: '',
        email: '',
        berat_badan: '',
        tinggi_badan: '',
        jarak_ke_sekolah: '',
        jarak_dalam_km: '',
        waktu_jam: '',
        waktu_menit: '',
        jumlah_saudara_kandung: '',
        status: '',
      },
      token: (JSON.parse(localStorage.getItem('Token'))).value,
      list_jenis_kelamin: [
        {
          value: 'Laki-Laki',
          text: 'Laki-Laki',
        },
        {
          value: 'Perempuan',
          text: 'Perempuan',
        },
      ],
      list_agama: [
        {
          id: 'Islam',
          name: 'Islam',
        },
        {
          id: 'Kristen/Protestan',
          name: 'Kristen/Protestan',
        },
        {
          id: 'Hindu',
          name: 'Hindu',
        },
        {
          id: 'Budha',
          name: 'Budha',
        },
        {
          id: 'Kong Hu Chu',
          name: 'Kong Hu Chu',
        },
        {
          id: 'Lainnya',
          name: 'Lainnya',
        },
      ],
      list_tempat_tinggal: [
        {
          id: 'Bersama Orang Tua',
          name: 'Bersama Orang Tua',
        },
        {
          id: 'Wali',
          name: 'Wali',
        },
        {
          id: 'Kos',
          name: 'Kos',
        },
        {
          id: 'Asrama',
          name: 'Asrama',
        },
        {
          id: 'Panti Asuhan',
          name: 'Panti Asuhan',
        },
        {
          id: 'Lainnya',
          name: 'Lainnya',
        },
      ],
      list_moda_transportasi: [
        {
          id: 'Jalan Kaki',
          name: 'Jalan Kaki',
        },
        {
          id: 'Kendaraan Pribadi',
          name: 'Kendaraan Pribadi',
        },
        {
          id: 'Kendaraan Umum',
          name: 'Kendaraan Umum',
        },
        {
          id: 'Jemputan Sekolah',
          name: 'Jemputan Sekolah',
        },
        {
          id: 'Kereta Api',
          name: 'Kereta Api',
        },
        {
          id: 'Ojek',
          name: 'Ojek',
        },
        {
          id: 'Andong/Bendi/Sado/Dokar/Delman/Beca',
          name: 'Andong/Bendi/Sado/Dokar/Delman/Beca',
        },
        {
          id: 'Perahu Penyebrangan/Rakit/Getek',
          name: 'Perahu Penyebrangan/Rakit/Getek',
        },
        {
          id: 'Lainnya',
          name: 'Lainnya',
        },
      ],
      list_alasan_layak_pip: [
        {
          id: 'Pemegang PKH/KPS/KIP',
          name: 'Pemegang PKH/KPS/KIP',
        },
        {
          id: 'Penerima BSM 2014',
          name: 'Penerima BSM 2014',
        },
        {
          id: 'Yatim Piatu/Panti Asuhan/Panti Sosial',
          name: 'Yatim Piatu/Panti Asuhan/Panti Sosial',
        },
        {
          id: 'Dampak Bencana Alam',
          name: 'Dampak Bencana Alam',
        },
        {
          id: 'Pernah Drop Out',
          name: 'Pernah Drop Out',
        },
        {
          id: 'Siswa Miskin/Rentan Miskin',
          name: 'Siswa Miskin/Rentan Miskin',
        },
        {
          id: 'Daerah Konflik',
          name: 'Daerah Konflik',
        },
        {
          id: 'Keluarga Terpidana',
          name: 'Keluarga Terpidana',
        },
        {
          id: 'Kelainan Fisik',
          name: 'Kelainan Fisik',
        },
      ],
      list_status: [
        {
          id: 'Pindah',
          name: 'Pindah',
        },
        {
          id: 'Keluar',
          name: 'Keluar',
        },
        {
          id: 'Lulus',
          name: 'Lulus',
        },
      ],
    };
  },
  computed: {
    url_upload() {
      return `${process.env.GATE_URL}file/upload`;
    },

    password() {
      if (this.show_pass) {
        return 'text';
      }
      return 'password';
    },

    confirm_password() {
      if (this.show_conpass) {
        return 'text';
      }
      return 'password';
    },
  },
  watch: {
  },
  created() {
    this.showLoading();
    const param = {
      pagination: {
        query: this.$route.params.nis,
        query_type: 'nis',
      },
    };
    this.getListSiswa(param).then((res) => {
      this.hideLoading();
      if (res.data.data.length > 0) {
        const dataDetail = res.data.data[0];
        this.data_master = dataDetail;
      }
    });
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKesiswaan', ['updateSiswa', 'deleteSiswa', 'getListSiswa', 'changePasswdSiswa']),

    getUrl(data) {
      this.data_master.foto_siswa = data;
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const param = this.data_master;
        param.tanggal_lahir = param.tanggal_lahir ? this.$moment(param.tanggal_lahir).format('YYYY-MM-DD') : '';
        param.tanggal_diterima = param.tanggal_diterima ? this.$moment(param.tanggal_diterima).format('YYYY-MM-DD') : '';
        this.updateSiswa(param).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$router.push('/data-siswa');
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.popoverChangePasswdShow = false;
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            nis: this.$route.params.nis,
          };
          this.deleteSiswa(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$router.push('/data-siswa');
              }, 1500);
            }
          });
        }
      });
    },

    createData() {
      this.popoverChangePasswdShow = false;
      this.$refs.modalChangePasswd.show();
    },

    closeModal() {
      this.$refs.modalChangePasswd.hide();
      this.data_pswd = {
        password: '',
        confirm_password: '',
      };
      setTimeout(() => {
        this.$v.data_pswd.$reset();
      }, 1000);
    },

    changePassword() {
      this.$v.data_pswd.$touch();
      if (!this.$v.data_pswd.$error) {
        const param = {
          id: this.data_master.id,
          password: this.data_pswd.password,
        };
        this.changePasswdSiswa(param).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.closeModal();
            }, 1500);
          }
        });
      }
    },
  },
  validations() {
    return {
      data_pswd: {
        password: { required },
        confirm_password: { required },
      },
      data_master: {
        nis: { required },
        nisn: { required },
        nama_siswa: { required },
        alamat_siswa: { required },
        foto_siswa: {},
        tempat_lahir: {},
        tanggal_lahir: {},
        jenis_kelamin: {},
        agama: {},
        warga_negara: {},
        anak_ke: {},
        jml_sdr_kandung: {},
        jml_sdr_tiri: {},
        jml_sdr_angkat: {},
        yatim_piatu: {},
        bahasa_harian: {},
        status_siswa: {},
        ket_status: {},
        post_date: {},
        nama_ayah: {},
        nama_ibu: {},
        alamat_ortu: {},
        notlp_ortu: {},
        nama_wali: {},
        alamat_wali: {},
        notlp_wali: {},
        pekerjaan_ayah: {},
        pekerjaan_ibu: {},
        pekerjaan_wali: {},
        tahunmasuk: {},
        sekolah_asal: {},
        diterima_dikelas: {},
        tanggal_diterima: {},
        nik_kitas: {},
        berkebutuhan_khusus: {},
        rt: {},
        rw: {},
        dusun: {},
        desa_kelurahan: {},
        kecamatan: {},
        kodepos: {},
        tempat_tinggal: {},
        moda_transportasi: {},
        penerima_kps: {},
        no_kps: {},
        layak_pip: {},
        alasan_layak_pip: {},
        no_kip: {},
        nama_tertera_di_kip: {},
        no_kks: {},
        bank: {},
        no_akta_lahir: {},
        no_rekening_bank: {},
        rekening_atas_nama: {},
        npsn_sekolah_asal: {},
        nik_ayah: {},
        tahun_lahir_ayah: {},
        pendidikan_ayah: {},
        penghasilan_ayah: {},
        kebutuhan_khusus_ayah: {},
        nik_ibu: {},
        tahun_lahir_ibu: {},
        pendidikan_ibu: {},
        penghasilan_ibu: {},
        kebutuhan_khusus_ibu: {},
        nik_wali: {},
        tahun_lahir_wali: {},
        pendidikan_wali: {},
        penghasilan_wali: {},
        no_telepon_rumah: {},
        no_telepon: {},
        email: {},
        berat_badan: {},
        tinggi_badan: {},
        jarak_ke_sekolah: {},
        jarak_dalam_km: {},
        waktu_jam: {},
        waktu_menit: {},
        jumlah_saudara_kandung: {},
        status: {},
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kesiswaan/siswa/jSiswaUpdate.vue